// extracted by mini-css-extract-plugin
export default {"home_stories_parent":"Stories_home_stories_parent__aAKby","container":"Stories_container__+NIkW","stories_inner":"Stories_stories_inner__uF5qb"};